import Grid from "@mui/material/Grid2";
import type { CorpusFeedView } from "../../../../../lib/corpusFeedView";
import { StatisticCard } from "../../../../../components/primitives/data-display/StatisticCard";
import { gaps } from "../../../../../components/primitives/spacing";

interface FeedMetricsProps {
  view: CorpusFeedView;
}

/** The numbers that sum a feed up, each on a small card; a dash stands for one that is not known. */
export function FeedMetrics({ view }: FeedMetricsProps) {
  const cardSpan = { xs: 6, sm: 4, md: "grow" } as const;

  return (
    <Grid container spacing={gaps.base}>
      <Grid size={cardSpan}>
        <StatisticCard label="Matches" mono pad="md">
          {view.returnedText ?? "—"}
        </StatisticCard>
      </Grid>
      <Grid size={cardSpan}>
        <StatisticCard label="Ingested" mono pad="md">
          {view.ingestedText ?? "—"}
        </StatisticCard>
      </Grid>
      <Grid size={cardSpan}>
        <StatisticCard label="Rejection rate" mono pad="md">
          {view.rejectionRateText ?? "—"}
        </StatisticCard>
      </Grid>
      <Grid size={cardSpan}>
        <StatisticCard label="Last run" pad="md">
          {view.lastRunText}
        </StatisticCard>
      </Grid>
      <Grid size={cardSpan}>
        <StatisticCard label="Next run" pad="md">
          {view.nextRunText}
        </StatisticCard>
      </Grid>
    </Grid>
  );
}
